import layoutHeaderAside from '@/layout/header-aside'

const meta = {
  auth: true
}

export default {
  path: '/finance',
  title: '财务管理',
  component: layoutHeaderAside,
  children: (pre => [{
    path: 'index',
    name: `${pre}index`,
    meta: {
      ...meta,
      cache: true,
      title: '财务首页'
    },
    component: () => import('@/views/finance/index')
  },
  {
    path: 'setting/account',
    name: `${pre}setting-account`,
    meta: {
      ...meta,
      cache: true,
      title: '账套'
    },
    component: () => import('@/views/finance/setting/account')
  },
  {
    path: 'setting/subject',
    name: `${pre}setting-subject`,
    meta: {
      ...meta,
      cache: true,
      title: '科目'
    },
    component: () => import('@/views/finance/setting/subject')
  },
  {
    path: 'setting/autoVoucher',
    name: `${pre}autoVoucher`,
    meta: {
      ...meta,
      cache: true,
      keepAlive: false,
      title: '自动转账设置'
    },
    component: () => import('@/views/finance/setting/autoVoucher')
  },
  {
    path: 'setting/projectType',
    name: `${pre}setting-projectType`,
    meta: {
      ...meta,
      cache: true,
      keepAlive: false,
      title: '项目类型'
    },
    component: () => import('@/views/finance/setting/projectType')
  },
  {
    path: 'setting/stockType',
    name: `${pre}setting-stockType`,
    meta: {
      ...meta,
      cache: true,
      keepAlive: false,
      title: '存货类型'
    },
    component: () => import('@/views/finance/setting/stockType')
  },
  {
    path: 'setting/userType',
    name: `${pre}setting-userType`,
    meta: {
      ...meta,
      cache: true,
      keepAlive: false,
      title: '客户类型'
    },
    component: () => import('@/views/finance/setting/userType')
  },
  {
    path: 'setting/supplierType',
    name: `${pre}setting-supplierType`,
    meta: {
      ...meta,
      cache: true,
      keepAlive: false,
      title: '供应商类型'
    },
    component: () => import('@/views/finance/setting/supplierType')
  },
  {
    path: 'setting/cashFlowType',
    name: `${pre}setting-cashFlowType`,
    meta: {
      ...meta,
      cache: true,
      keepAlive: false,
      title: '现金流量项目'
    },
    component: () => import('@/views/finance/setting/cashFlowType')
  },
  // {
  //   path: 'setting/cashFlowPeriod',
  //   name: `${pre}setting-cashFlowPeriod`,
  //   meta: {
  //     ...meta,
  //     cache: true,
  //     keepAlive: false,
  //     title: '现金流量项目期初'
  //   },
  //   component: () => import('@/views/finance/setting/cashFlowPeriod')
  // },
  {
    path: 'setting/cashFlowSheetPeriod',
    name: `${pre}setting-cashFlowSheetPeriod`,
    meta: {
      ...meta,
      cache: true,
      keepAlive: false,
      title: '现金流量表期初'
    },
    component: () => import('@/views/finance/setting/cashFlowSheetPeriod')
  },
  // {
  //   path: 'setting/fundProject',
  //   name: `${pre}setting-fundProject`,
  //   meta: {
  //     ...meta,
  //     cache: true,
  //     keepAlive: false,
  //     title: '资金项目'
  //   },
  //   component: () => import('@/views/finance/setting/fundProject')
  // },
  {
    path: 'setting/supplementaryAccount',
    name: `${pre}setting-supplementaryAccount`,
    meta: {
      ...meta,
      cache: true,
      keepAlive: false,
      title: '辅助核算'
    },
    component: () => import('@/views/finance/setting/supplementaryAccount')
  },
  {
    path: 'setting/period',
    name: `${pre}setting-period`,
    meta: {
      ...meta,
      cache: true,
      title: '期初'
    },
    component: () => import('@/views/finance/setting/period')
  },
  {
    path: 'setting/currency',
    name: `${pre}setting-currency`,
    meta: {
      ...meta,
      cache: true,
      title: '币别'
    },
    component: () => import('@/views/finance/setting/currency')
  },
  {
    path: 'setting/voucherGroup',
    name: `${pre}setting-voucherGroup`,
    meta: {
      ...meta,
      cache: true,
      title: '凭证字'
    },
    component: () => import('@/views/finance/setting/voucherGroup')
  },

  {
    path: 'setting/expenseShareSetting',
    name: `${pre}setting-expense-share`,
    meta: {
      ...meta,
      cache: true,
      title: '分摊比例设置'
    },
    component: () => import('@/views/finance/setting/expenseShareSetting')
  },

  {
    path: 'voucher/add',
    name: `${pre}setting-voucher-add`,
    meta: {
      ...meta,
      cache: true,
      title: '新增凭证'
    },
    component: () => import('@/views/finance/voucher/detail')
  },
  // {
  //   path: 'voucher/orderVoucherType',
  //   name: `${pre}order_voucher_type`,
  //   meta: {
  //     ...meta,
  //     cache: true,
  //     title: '凭证模板类型'
  //   },
  //   component: () => import('@/views/finance/setting/orderVoucherType')
  // },
  {
    path: 'voucher/detail',
    name: `${pre}setting-voucher-detail`,
    meta: {
      ...meta,
      cache: true,
      title: '凭证详细'
    },
    component: () => import('@/views/finance/voucher/detail')
  },
  {
    path: 'voucher/page',
    name: `${pre}setting-voucher-page`,
    meta: {
      ...meta,
      cache: true,
      title: '查看凭证'
    },
    component: () => import('@/views/finance/voucher/page')
  },

  {
    path: 'accountBook/subsidiaryLedger',
    name: `${pre}accountBook-subsidiaryLedger`,
    meta: {
      ...meta,
      cache: true,
      title: '明细账'
    },
    component: () => import('@/views/finance/accountBook/subsidiaryLedger')
  },
  {
    path: 'accountBook/accountsSummary',
    name: `${pre}accountBook-accountsSummary`,
    meta: {
      ...meta,
      cache: true,
      title: '科目汇总表'
    },
    component: () => import('@/views/finance/accountBook/accountsSummary')
  },
  {
    path: 'accountBook/voucherSummary',
    name: `${pre}accountBook-voucherSummary`,
    meta: {
      ...meta,
      cache: true,
      title: '凭证汇总表'
    },
    component: () => import('@/views/finance/accountBook/voucherSummary')
  },
  {
    path: 'accountBook/yfdz/qtwlqkb',
    name: `${pre}accountBook-qtwlqkb`,
    meta: {
      ...meta,
      cache: true,
      title: '其他往来情况表'
    },
    component: () => import('@/views/finance/accountBook/yfdz/qtwlqkb')
  },
  {
    path: 'accountBook/yfdz/tzqkb',
    name: `${pre}accountBook-tzqkb`,
    meta: {
      ...meta,
      cache: true,
      title: '投资情况表'
    },
    component: () => import('@/views/finance/accountBook/yfdz/tzqkb')
  },
  {
    path: 'accountBook/yfdz/sfmxb',
    name: `${pre}accountBook-sfmxb`,
    meta: {
      ...meta,
      cache: true,
      title: '税费明细表'
    },
    component: () => import('@/views/finance/accountBook/yfdz/sfmxb')
  },
  {
    path: 'accountBook/yfdz/fyzbb',
    name: `${pre}accountBook-fyzbb`,
    meta: {
      ...meta,
      cache: true,
      title: '费用占比表'
    },
    component: () => import('@/views/finance/accountBook/yfdz/fyzbb')
  },
  {
    path: 'accountBook/yfdz/zzfymxb',
    name: `${pre}accountBook-zzfymxb`,
    meta: {
      ...meta,
      cache: true,
      title: '制造费用明细表'
    },
    component: () => import('@/views/finance/accountBook/yfdz/zzfymxb')
  },
  {
    path: 'accountBook/yfdz/yszlfxb',
    name: `${pre}accountBook-yszlfxb`,
    meta: {
      ...meta,
      cache: true,
      title: '应收账龄分析表'
    },
    component: () => import('@/views/finance/accountBook/yfdz/yszlfxb')
  },
  {
    path: 'accountBook/yfdz/yfzlfxb',
    name: `${pre}accountBook-yfzlfxb`,
    meta: {
      ...meta,
      cache: true,
      title: '应付账龄分析表'
    },
    component: () => import('@/views/finance/accountBook/yfdz/yfzlfxb')
  },
  {
    path: 'accountBook/multiColumnLedger',
    name: `${pre}accountBook-multiColumnLedger`,
    meta: {
      ...meta,
      cache: true,
      title: '多栏账'
    },
    component: () => import('@/views/finance/accountBook/multiColumnLedger')
  },
  {
    path: 'accountBook/aaSubsidiaryLedger',
    name: `${pre}accountBook-aaSubsidiaryLedger`,
    meta: {
      ...meta,
      cache: true,
      title: '核算项目明细账'
    },
    component: () => import('@/views/finance/accountBook/aaSubsidiaryLedger')
  },
  {
    path: 'saleInvoice',
    name: `${pre}saleInvoice`,
    meta: {
      ...meta,
      cache: true,
      title: '销售开票登记'
    },
    component: () => import('@/views/finance/saleInvoice')
  },
  {
    path: 'payable',
    name: `${pre}payable`,
    meta: {
      ...meta,
      cache: true,
      title: '应付账款'
    },
    component: () => import('@/views/finance/payable')
  },
  {
    path: 'invoice/examine',
    name: `${pre}setting-invoice-examine`,
    meta: {
      ...meta,
      cache: true,
      title: '待审核发票'
    },
    component: () => import('@/views/finance/invoice/examine')
  },
  {
    path: 'invoice/sales',
    name: `${pre}setting-invoice-sales`,
    meta: {
      ...meta,
      cache: true,
      title: '销项发票'
    },
    component: () => import('@/views/finance/invoice/sales')
  },
  {
    // path: 'invoice/income',
    // name: `${pre}setting-invoice-income`,
    path: 'invoice/purchase',
    name: `${pre}setting-invoice-purchase`,
    meta: {
      ...meta,
      cache: true,
      title: '进项发票'
    },
    // component: () => import('@/views/finance/invoice/income')
    component: () => import('@/views/finance/invoice/purchase')
  },
  {
    path: 'returnMoney',
    name: `${pre}returnMoney`,
    meta: {
      ...meta,
      cache: true,
      title: '回款登记'
    },
    component: () => import('@/views/finance/returnMoney')
  },
  {
    path: 'returnMoneyList',
    name: `${pre}returnMoneyList`,
    meta: {
      ...meta,
      cache: true,
      title: '回款记录'
    },
    component: () => import('@/views/finance/returnMoneyList')
  },
  {
    path: 'payment',
    name: `${pre}payment`,
    meta: {
      ...meta,
      cache: true,
      title: '付款登记'
    },
    component: () => import('@/views/finance/payment')
  },
  {
    path: 'paymentLog',
    name: `${pre}paymentLog`,
    meta: {
      ...meta,
      cache: true,
      title: '付款记录'
    },
    component: () => import('@/views/finance/paymentLog')
  }, {
    path: 'report/balanceSheet',
    name: `${pre}report-balanceSheet`,
    meta: {
      ...meta,
      cache: true,
      title: '资产负债表'
    },
    component: () => import('@/views/finance/report/balanceSheet')
  },
  {
    path: 'report/profitStatement',
    name: `${pre}report-profitStatement`,
    meta: {
      ...meta,
      cache: true,
      title: '利润表'
    },
    component: () => import('@/views/finance/report/profitStatement')
  },
  // {
  //   path: 'profit',
  //   name: `${pre}profit`,
  //   meta: {
  //     ...meta,
  //     cache: true,
  //     title: '利润表'
  //   },
  //   component: () => import('@/views/finance/report/profit')
  // },
  {
    path: 'report/cashFlow',
    name: `${pre}report-cashFlow`,
    meta: {
      ...meta,
      cache: true,
      title: '现金流量表'
    },
    component: () => import('@/views/finance/report/cashFlow')
  },
  {
    path: 'report/monthlyFundStatement',
    name: `${pre}report-monthlyFundStatement`,
    meta: {
      ...meta,
      cache: true,
      title: '资金月报表'
    },
    component: () => import('@/views/finance/report/monthlyFundStatement')
  },
  // {
  //   path: 'report/audit',
  //   name: `${pre}-report-audit`,
  //   meta: { ...meta, cache: true, title: '现金流量表（审计）' },
  //   component: () => import('@/views/finance/report/audit')
  // },
  {
    path: 'report/deptFee',
    name: `${pre}deptFee`,
    meta: {
      ...meta,
      cache: true,
      title: '部门费用表'
    },
    component: () => import('@/views/finance/report/deptFee')
  },
  {
    path: 'report/yearFee',
    name: `${pre}yearFee`,
    meta: {
      ...meta,
      cache: true,
      title: '年度费用表'
    },
    component: () => import('@/views/finance/report/yearFee')
  },
  {
    path: 'checkout',
    name: `${pre}checkout`,
    meta: {
      ...meta,
      cache: true,
      title: '期末结转'
    },
    component: () => import('@/views/finance/checkout')
  },
  {
    path: 'checkoutTemplate',
    name: `${pre}checkoutTemplate`,
    meta: {
      ...meta,
      cache: true,
      title: '期末结转模板'
    },
    component: () => import('@/views/finance/checkoutTemplate')
  },
  {
    path: 'subjectBalance',
    name: `${pre}subjectBalance`,
    meta: {
      ...meta,
      cache: true,
      title: '科目余额'
    },
    component: () => import('@/views/finance/subjectBalance')
  },
  {
    path: 'accountBook/generalLedger',
    name: `${pre}generalLedger`,
    meta: {
      ...meta,
      cache: true,
      title: '总账'
    },
    component: () => import('@/views/finance/generalLedger')
  },
  {
    path: 'wages/payroll',
    name: `${pre}wages`,
    meta: {
      ...meta,
      cache: true,
      title: '工资表'
    },
    component: () => import('@/views/finance/wages')
  },
  // {
  //   path: 'wages/payroll/detail',
  //   name: `${pre}wagesDetail`,
  //   meta: { ...meta, cache: true, title: '工资表详情' },
  //   component: () => import('@/views/finance/wages/components/PageMain/components/MainForm')
  // },
  {
    path: 'cashier/template',
    name: `${pre}template`,
    meta: {
      ...meta,
      cache: true,
      title: '收支模板'
    }
  },
  {
    path: 'cash/template/incomeTemplate',
    name: `${pre}incomeTemplate`,
    meta: {
      ...meta,
      cache: true,
      title: '收入模板'
    },
    component: () => import('@/views/finance/cashier/template/incomeTemplate')
  },
  {
    path: 'cash/template/expenditureTemplate',
    name: `${pre}expenditureTemplate`,
    meta: {
      ...meta,
      cache: true,
      title: '支出模板'
    },
    component: () => import('@/views/finance/cashier/template/expenditureTemplate')
  },
  {
    path: 'cashier/type',
    name: `${pre}type`,
    meta: {
      ...meta,
      cache: true,
      title: '收支类别'
    }
  },
  {
    path: 'cash/type/income',
    name: `${pre}income`,
    meta: {
      ...meta,
      cache: true,
      title: '收入'
    },
    component: () => import('@/views/finance/cashier/type/income')
  },
  {
    path: 'cash/type/expenditure',
    name: `${pre}expenditure`,
    meta: {
      ...meta,
      cache: true,
      title: '支出'
    },
    component: () => import('@/views/finance/cashier/type/expenditure')
  },
  {
    path: 'cash/accountManage',
    name: `${pre}accountManage`,
    meta: {
      ...meta,
      cache: true,
      title: '账户管理'
    },
    component: () => import('@/views/finance/cashier/accountManage')
  },
  {
    path: 'cash/cashJournal',
    name: `${pre}cashJournal`,
    meta: {
      ...meta,
      cache: true,
      title: '现金日记账'
    },
    component: () => import('@/views/finance/cashier/cashJournal')
  },
  {
    path: 'invoice/template',
    name: `${pre}template`,
    meta: {
      ...meta,
      cache: true,
      title: '凭证模板'
    }
  },
  {
    path: 'invoice/template/purchaseTemplate',
    name: `${pre}purchaseTemplate`,
    meta: {
      ...meta,
      cache: true,
      title: '进项模板'
    },
    component: () => import('@/views/finance/invoice/template/purchaseTemplate')
  },
  {
    path: 'invoice/template/saleTemplate',
    name: `${pre}saleTemplate`,
    meta: {
      ...meta,
      cache: true,
      title: '销项模板'
    },
    component: () => import('@/views/finance/invoice/template/saleTemplate')
  },
  {
    path: 'invoice/feeNote',
    name: `${pre}feeNote`,
    meta: {
      ...meta,
      cache: true,
      title: '费用票据'
    },
    component: () => import('@/views/finance/invoice/feeNote')
  },
  {
    path: 'invoice/feeNoteExamine',
    name: `${pre}feeNoteExamine`,
    meta: {
      ...meta,
      cache: true,
      title: '待审核费用票据'
    },
    component: () => import('@/views/finance/invoice/feeNoteExamine')
  },
  {
    path: 'bankStatement',
    name: `${pre}bankStatement`,
    meta: {
      ...meta,
      cache: true,
      title: '银行流水'
    },
    component: () => import('@/views/finance/bankStatement')
  },
  {
    path: 'bankReconciliation/bankReconciliation',
    name: `${pre}bankReconciliation`,
    meta: {
      ...meta,
      cache: true,
      title: '银行对账单'
    },
    component: () => import('@/views/finance/bankReconciliation/bankReconciliation')
  },
  {
    path: 'billSummary',
    name: `${pre}billSummary`,
    meta: {
      ...meta,
      cache: true,
      title: '票据汇总'
    },
    component: () => import('@/views/finance/billSummary')
  },

  {
    path: 'costAccounting/manufacture',
    name: `${pre}manufacture`,
    meta: {
      ...meta,
      cache: true,
      title: '成本核算(制造)'
    },
    component: () => import('@/views/finance/costAccounting/manufacture')
  },
  {
    path: 'costAccounting/service',
    name: `${pre}service`,
    meta: {
      ...meta,
      cache: true,
      title: '成本核算(服务)'
    },
    component: () => import('@/views/finance/costAccounting/service')
  },
  {
    path: 'pendingExpenses/list',
    name: `${pre}pendingExpenses`,
    meta: { ...meta, cache: true, title: '待摊费用' },
    component: () => import('@/views/finance/pendingExpenses')
  },
  {
    path: 'fixedAssets/fixedAssetType',
    name: `${pre}fixedAssetType`,
    meta: { ...meta, cache: true, title: '固定资产类别' },
    component: () => import('@/views/finance/fixedAssets/fixedAssetType')
  },
  {
    path: 'fixedAssets/faSummary',
    name: `${pre}faSummary`,
    meta: { ...meta, cache: true, title: '固定资产汇总' },
    component: () => import('@/views/finance/fixedAssets/faSummary')
  },
  {
    path: 'fixedAssets/fixedAssets',
    name: `${pre}fixedAssets`,
    meta: { ...meta, cache: true, title: '固定资产管理' },
    component: () => import('@/views/finance/fixedAssets/fixedAssets')
  },
  {
    path: 'fixedAssets/depreciationLedger',
    name: `${pre}depreciationLedger`,
    meta: { ...meta, cache: true, title: '固定资产折旧明细' },
    component: () => import('@/views/finance/fixedAssets/depreciationLedger')
  },
  {
    path: 'fixedAssets/depreciationLedger',
    name: `${pre}depreciationLedger`,
    meta: { ...meta, cache: true, title: '固定资产折旧明细' },
    component: () => import('@/views/finance/fixedAssets/depreciationLedger')
  },
  {
    path: 'fixedAssets/changeHistory',
    name: `${pre}changeHistory`,
    meta: { ...meta, cache: true, title: '变更历史' },
    component: () => import('@/views/finance/fixedAssets/fixedAssets/components/PageMain/components/MainForm/changeHistory')
  },
  {
    path: 'fixedAssets/assetDetail',
    name: `${pre}assetDetail`,
    meta: { ...meta, cache: true, title: '固定资产明细' },
    component: () => import('@/views/finance/fixedAssets/fixedAssets/components/PageMain/components/MainForm/assetDetail')
  },
  {
    path: 'orderVoucherTemplate',
    name: `${pre}orderVoucherTemplate`,
    meta: {
      ...meta,
      cache: true,
      title: '单据凭证模板'
    },
    component: () => import('@/views/finance/orderVoucherTemplate')
  },
  {
    path: 'receiveBill',
    name: `${pre}receiveBill`,
    meta: {
      ...meta,
      cache: true,
      title: '销售退款'
    },
    component: () => import('@/views/finance/receiveBill')
  },
  {
    path: 'receivableForSaleOutStock',
    name: `${pre}receivableForSaleOutStock`,
    meta: {
      ...meta,
      cache: true,
      title: '销售出库应收'
    },
    component: () => import('@/views/finance/receivableForSaleOutStock')
  },
  {
    path: 'receivableForSaleReturn',
    name: `${pre}receivableForSaleReturn`,
    meta: {
      ...meta,
      cache: true,
      title: '销售退货应收'
    },
    component: () => import('@/views/finance/receivableForSaleReturn')
  },

  {
    path: 'payableForPurchaseInStock',
    name: `${pre}payableForPurchaseInStock`,
    meta: {
      ...meta,
      cache: true,
      title: '采购入库应付'
    },
    component: () => import('@/views/finance/payableForPurchaseInStock')
  },
  // {
  //   path: 'outSource',
  //   name: `${pre}outSource`,
  //   meta: {
  //     ...meta,
  //     cache: true,
  //     title: '委外订单应付'
  //   },
  //   component: () => import('@/views/finance/outSource')
  // },
  {
    path: 'payableForPurchaseReturn',
    name: `${pre}payableForPurchaseReturn`,
    meta: {
      ...meta,
      cache: true,
      title: '采购退货应付'
    },
    component: () => import('@/views/finance/payableForPurchaseReturn')
  },

  {
    path: 'receiveBillForReceivable',
    name: `${pre}receiveBillForReceivable`,
    meta: {
      ...meta,
      cache: true,
      title: '销售收款'
    },
    component: () => import('@/views/finance/receiveBillForReceivable')
  },
  // {
  //   path: 'receiveBillForSaleRefund',
  //   name: `${pre}receiveBillForSaleRefund`,
  //   meta: {
  //     ...meta,
  //     cache: true,
  //     title: '销售退款'
  //   },
  //   component: () => import('@/views/finance/receiveBillForSaleRefund')
  // },
  {
    path: 'payBillForAdvance',
    name: `${pre}payBillForAdvance`,
    meta: {
      ...meta,
      cache: true,
      title: '采购预付款'
    },
    component: () => import('@/views/finance/payBillForAdvance')
  },
  {
    path: 'payBillForPurchaseOrder',
    name: `${pre}payBillForPurchaseOrder`,
    meta: {
      ...meta,
      cache: true,
      title: '采购付款'
    },
    component: () => import('@/views/finance/payBillForPurchaseOrder')
  },
  {
    path: 'payBillForCost',
    name: `${pre}payBillForCost`,
    meta: {
      ...meta,
      cache: true,
      title: '费用付款单'
    },
    component: () => import('@/views/finance/payBillForCost')
  },
  {
    path: 'saleOutStock',
    name: `${pre}saleOutStock`,
    meta: {
      ...meta,
      cache: true,
      title: '销售出库单'
    },
    component: () => import('@/views/finance/saleOutStock')
  },

  {
    path: 'saleFreeOutStock',
    name: `${pre}saleFreeOutStock`,
    meta: {
      ...meta,
      cache: true,
      title: '赠品出库单'
    },
    component: () => import('@/views/finance/saleFreeOutStock')
  },

  // {
  //   path: 'receiveBillForRecharge',
  //   name: `${pre}receiveBillForRecharge`,
  //   meta: {
  //     ...meta,
  //     cache: true,
  //     title: '充值收款'
  //   },
  //   component: () => import('@/views/finance/receiveBillForRecharge')
  // },
  // {
  //   path: 'receiveBillForRebate',
  //   name: `${pre}receiveBillForRebate`,
  //   meta: {
  //     ...meta,
  //     cache: true,
  //     title: '充值返利付款'
  //   },
  //   component: () => import('@/views/finance/receiveBillForRebate')
  // },
  {
    path: 'otherInStock',
    name: `${pre}otherInStock`,
    meta: {
      ...meta,
      cache: true,
      title: '其他入库应付'
    },
    component: () => import('@/views/finance/otherInStock')
  },
  {
    path: 'otherOutStock',
    name: `${pre}otherOutStock`,
    meta: {
      ...meta,
      cache: true,
      title: '其他出库应收'
    },
    component: () => import('@/views/finance/otherOutStock')
  },
  {
    path: 'outSourceReceive',
    name: `${pre}outSourceReceive`,
    meta: {
      ...meta,
      cache: true,
      title: '委外发出'
    },
    component: () => import('@/views/finance/outSourceReceive')
  },
  {
    path: 'payableForProcess',
    name: `${pre}payableForProcess`,
    meta: {
      ...meta,
      cache: true,
      title: '委外加工'
    },
    component: () => import('@/views/finance/payableForProcess')
  },
  {
    path: 'payableForOutSource',
    name: `${pre}payableForOutSource`,
    meta: {
      ...meta,
      cache: true,
      title: '委外入库'
    },
    component: () => import('@/views/finance/payableForOutSource')
  },

  {
    path: 'outSourceProcessInStock',
    name: `${pre}outSourceProcessInStock`,
    meta: {
      ...meta,
      cache: true,
      title: '委外加工入库'
    },
    component: () => import('@/views/finance/outSourceProcessInStock')
  },

  {
    path: 'otherPayable',
    name: `${pre}otherPayable`,
    meta: {
      ...meta,
      cache: true,
      title: '其他应付'
    },
    component: () => import('@/views/finance/otherPayable')
  },
  {
    path: 'otherReceivable',
    name: `${pre}otherReceivable`,
    meta: {
      ...meta,
      cache: true,
      title: '其他应收'
    },
    component: () => import('@/views/finance/otherReceivable')
  },
  {
    path: 'pickMtrl',
    name: `${pre}pickMtrl`,
    meta: {
      ...meta,
      cache: true,
      title: '生产领料'
    },
    component: () => import('@/views/finance/pickMtrl')
  },
  {
    path: 'feedMtrl',
    name: `${pre}feedMtrl`,
    meta: {
      ...meta,
      cache: true,
      title: '生产补料'
    },
    component: () => import('@/views/finance/feedMtrl')
  },

  {
    path: 'returnMtrl',
    name: `${pre}returnMtrl`,
    meta: {
      ...meta,
      cache: true,
      title: '生产退料'
    },
    component: () => import('@/views/finance/returnMtrl')
  },

  {
    path: 'prdInStock',
    name: `${pre}prdInStock`,
    meta: {
      ...meta,
      cache: true,
      title: '生产入库'
    },
    component: () => import('@/views/finance/prdInStock')
  },
  {
    path: 'loanOrder',
    name: `${pre}loanOrder`,
    meta: {
      ...meta,
      cache: true,
      title: '借款单'
    },
    component: () => import('@/views/finance/loanOrder')
  },
  {
    path: 'repaymentOrder',
    name: `${pre}repaymentOrder`,
    meta: {
      ...meta,
      cache: true,
      title: '还款单'
    },
    component: () => import('@/views/finance/repaymentOrder')
  },
  {
    path: 'otherPaymentOrder',
    name: `${pre}otherPaymentOrder`,
    meta: {
      ...meta,
      cache: true,
      title: '出款单'
    },
    component: () => import('@/views/finance/otherPaymentOrder')
  },
  {
    path: 'expenseOrder',
    name: `${pre}expenseOrder`,
    meta: {
      ...meta,
      cache: true,
      title: '报销单'
    },
    component: () => import('@/views/finance/expenseOrder')
  },
  {
    path: 'refundOrder',
    name: `${pre}refundOrder`,
    meta: {
      ...meta,
      cache: true,
      title: '退款单'
    },
    component: () => import('@/views/finance/refundOrder')
  },
  // {
  //   path: 'expenseItem',
  //   name: `${pre}expenseItem`,
  //   meta: {
  //     ...meta,
  //     cache: true,
  //     title: '费用项目'
  //   },
  //   component: () => import('@/views/finance/expenseItem')
  // },
  {
    path: 'expenseItemToVoucher',
    name: `${pre}expenseItemToVoucher`,
    meta: {
      ...meta,
      cache: true,
      title: '费用录入单'
    },
    component: () => import('@/views/finance/expenseItemToVoucher')
  },


  {
    path: 'expenseControl',
    name: `${pre}expenseControl`,
    meta: {
      ...meta,
      cache: true,
      title: '费用预算单'
    },
    component: () => import('@/views/finance/expenseControl')
  },
  {
    path: 'chargeOffOrder',
    name: `${pre}chargeOffOrder`,
    meta: {
      ...meta,
      cache: true,
      title: '核销单'
    },
    component: () => import('@/views/finance/chargeOffOrder')
  },
  {
    path: 'accountBook/containerSituationDetail',
    name: `${pre}accountBook-containerSituationDetail`,
    meta: {
      ...meta,
      cache: true,
      title: '货柜情况明细表'
    },
    component: () => import('@/views/finance/accountBook/containerSituationDetail')
  },

  {
    path: 'pieceRate',
    name: `${pre}pieceRate`,
    meta: {
      ...meta,
      cache: true,
      title: '计件工资'
    },
    component: () => import('@/views/finance/pieceRate')
  },

  {
    path: 'checkCountBillSurplus',
    name: `${pre}checkCountBillSurplus`,
    meta: {
      ...meta,
      cache: true,
      title: '盘盈单'
    },
    component: () => import('@/views/finance/checkCountBillSurplus')
  },

  {
    path: 'checkCountBillLoss',
    name: `${pre}checkCountBillLoss`,
    meta: {
      ...meta,
      cache: true,
      title: '盘亏单'
    },
    component: () => import('@/views/finance/checkCountBillLoss')
  },
  {
    path: 'supplierCheckCountBillSurplus',
    name: `${pre}supplierCheckCountBillSurplus`,
    meta: {
      ...meta,
      cache: true,
      title: '供应商盘盈单'
    },
    component: () => import('@/views/finance/supplierCheckCountBillSurplus')
  },

  {
    path: 'supplierCheckCountBillLoss',
    name: `${pre}supplierCheckCountBillLoss`,
    meta: {
      ...meta,
      cache: true,
      title: '供应商盘亏单'
    },
    component: () => import('@/views/finance/supplierCheckCountBillLoss')
  },

  ])('finance-')
}